<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Mitglied löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du das Mitglied "{{member.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="del()" :loading="loading">Löschen</v-btn>
        <v-btn color="primary" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';


export default {
  name: 'DlgMemberDelete',
  components: {
    // VueEditor,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  props: ['member'],
  methods: {
    ...mapActions({
      memberDel: 'members/del',
      memberRead: 'members/read',
    }),
    del() {
      this.loading = true;
      this.memberDel(this.member).then((res) => {
        this.loading = false;
        if (res) {
          this.memberRead();
          this.dialog = false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
